'use strict';
const _ = require('lodash');

module.exports = (record, prefix) => {
  const ensurePrefix = (itm) => {
    if (_.isEmpty(prefix)) {
      return itm;
    }

    return `${prefix}${_.upperFirst(itm)}`;
  };

  let countryField = 'country';

  if (!_.isEmpty(prefix)) {
    countryField = `${prefix}Country`;
  }

  const country = _.get(record, [countryField, 'countryCodeAlpha2']);

  if (_.isEmpty(country)) {
    return;
  }

  if (country === 'NL') {
    const parts = [];

    const street = _.get(record, ensurePrefix('street'));
    const houseNumber = _.get(record, ensurePrefix('houseNumber_i'));
    const postalCode = _.get(record, ensurePrefix('postalCode'));
    const city = _.get(record, ensurePrefix('city'));

    if (!_.isNil(street) && !_.isNil(houseNumber)) {
      parts.push(_.trim(`${street} ${houseNumber}`));
    } else {
      parts.push(street);
      parts.push(houseNumber);
    }

    if (!_.isNil(postalCode) && !_.isNil(city)) {
      parts.push(_.trim(`${postalCode} ${city}`));
    } else {
      parts.push(postalCode);
      parts.push(city);
    }

    parts.push(_.get(record, [countryField, 'display']));

    return _.reject(parts, _.isEmpty).join(',');
  } else {
    const parts = [
      _.get(record, ensurePrefix('addressLine1')),
      _.get(record, ensurePrefix('addressLine2')),
      _.get(record, ensurePrefix('addressLine3')),
      _.get(record, ensurePrefix('addressLine4')),
      _.get(record, [countryField, 'display'])
    ];

    return _.reject(parts, _.isEmpty).join(',');
  }
};
